import type { ReactNode } from 'react';
import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { Badge } from 'Components/frameworks/badge/Badge';
import type { IconName } from 'Components/frameworks/icon/Icon';
import 'Components/frameworks/icon/Icon';
type SimpleNotificationProps = {
  id: string;
  title?: string;
  content?: string | Node;
  iconName: IconName;
  className?: string;
  linkUrl?: string;
  linkLabel?: string;
};
export const SimpleNotification = ({
  id,
  title,
  content,
  iconName,
  className,
  linkUrl,
  linkLabel,
}: SimpleNotificationProps) => {
  return (
    <div
      data-testid={`SimpleNotification-${id}`}
      className={classnames('h-full rounded-12 border-1 border-lightGrey bg-white p-20', className)}
    >
      <div
        data-testid={`SimpleNotification-icon-${id}`}
        className={classnames('flex gap-20', {
          'items-center': !title && !linkUrl,
          'items-start': title || linkUrl,
        })}
      >
        <Badge
          className="size-48 border-lightSand bg-lightSand text-black"
          iconName={iconName}
          iconSize="24px"
          variant="pill"
        />
        <div className="text-start text-16 leading-normal">
          {title && <p className="mb-[8px] font-semibold">{title}</p>}
          {typeof content === 'string' ? <p className="text-14">{content}</p> : content}
          {linkUrl && linkLabel && (
            <a
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-block text-14 font-semibold underline"
              data-testid={`SimpleNotification-link-${id}`}
            >
              {linkLabel}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};
